/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData } from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData';
import {
    instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataToJSON,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData';

/**
 * @type FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken
 * 
 * @export
 */
export type FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken = FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData;

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData(json)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSON(json: any): any {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData(value)) {
        return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthDataToJSON(value as FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersGameAccessTokenGameAccessTokenAuthData);
    }

    return {};
}

